import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08abb5ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "FirstPageBackground" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "headerBtnContainer" }
const _hoisted_4 = { id: "selectSearchContainer" }
const _hoisted_5 = { class: "selectContainer" }
const _hoisted_6 = { class: "selectContainer" }
const _hoisted_7 = { id: "inputSearchContainer" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "menuContainer" }, "查询院校", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "headerTips" }, "注：内部编码不可用于填报", -1))
const _hoisted_10 = { id: "mainBody" }
const _hoisted_11 = { id: "IncludingColleges" }
const _hoisted_12 = { class: "collegesContainer" }
const _hoisted_13 = { class: "collegesLine1" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "collegesLine2" }

import {ref, reactive, nextTick} from 'vue'
  import {ElMessage} from 'element-plus';
  import {ElScrollbar} from 'element-plus'
  import {Search} from '@element-plus/icons-vue'
  import {
    getCollegeInfoByInput,
    getCollegeInfoBySelect, getCollegeInfoBySelect2,
    getSelectSerachCity,
    getSelectSerachProvince, searchGetAllColleges, searchGetColleges
  } from "@/network/axios";
  import {useRouter, useRoute} from "vue-router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FirstPage',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();
  //检查 机型
  let _isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  };
  //如果是手机 就跳转手机页面
  if (_isMobile()) {
    router.push('/MobileFirstPage')
  }

  let firstPageInfo = reactive({
    inputSearchCollegeName: '',
    selectSearchProvince: '',
    selectSearchProvinceArray: [],
    selectSearchCity: '',
    selectSearchCityArray: [],
    collegeInfoArray: [],
  });

  //获取 el-scrollbar滚动条 id
  let mainBodyScrollbar = ref();

  //刚进页面 获取 头部第一个下拉框的值
  getSelectSerachProvince('/search/getProvince').then((res) => {
    firstPageInfo.selectSearchProvinceArray = [];
    firstPageInfo.selectSearchProvinceArray = res.data.data
  });


  //第一个下拉框有变动 获取第二个下拉框的值
  let select1Change = (val: any) => {
    firstPageInfo.selectSearchCity = '';
    getSelectSerachCity('/search/getCity', {
      params: {
        province: val
      }
    }).then((res) => {
      firstPageInfo.selectSearchCityArray = [];
      firstPageInfo.selectSearchCityArray = res.data.data;

    })
    pageChange()
  };

  let select2Change = () => {
    pageChange()
  }


  let pageChange = () => {
    nextTick(() => {
      mainBodyScrollbar.value!.setScrollTop(0)
    })
    searchGetColleges('/search/getColleges', {
      params: {
        province: firstPageInfo.selectSearchProvince,
        city: firstPageInfo.selectSearchCity,
        collegeName: firstPageInfo.inputSearchCollegeName,
      }
    }).then((res) => {
      firstPageInfo.collegeInfoArray = [];
      firstPageInfo.collegeInfoArray = res.data.data;
    })
  }

  pageChange()

  //==========点击 跳转 页面================//
  let goCollegeSituation = (n: any) => {
    let id = ref(firstPageInfo.collegeInfoArray[n].collegeCode);
    // console.log(id.value)
    window.open('/' + id.value, '_blank')
  };

  let goTransferPage = () => {
    window.open('/TransferPage/0101', '_blank')
  };

  let goMajorSearch = () => {
    window.open('/MajorSearch')
  };

  let goProfessionSearch = () => {
    window.open('/ProfessionSearch')
  };




return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_select, {
                modelValue: _unref(firstPageInfo).selectSearchProvince,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(firstPageInfo).selectSearchProvince) = $event)),
                clearable: "",
                onClear: _unref(pageChange),
                onChange: _unref(select1Change),
                placeholder: "选择省份",
                "popper-class": "elPopperSelect"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstPageInfo).selectSearchProvinceArray, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      value: item,
                      label: item
                    }, null, 8, ["value", "label"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue", "onClear", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: _unref(firstPageInfo).selectSearchCity,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(firstPageInfo).selectSearchCity) = $event)),
                placeholder: "选择城市",
                clearable: "",
                onClear: _unref(pageChange),
                onChange: _unref(select2Change),
                "popper-class": "elPopperSelect"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstPageInfo).selectSearchCityArray, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      value: item,
                      label: item
                    }, null, 8, ["value", "label"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue", "onClear", "onChange"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              id: "majorsInquireBtn",
              onClick: _unref(goTransferPage)
            }, {
              default: _withCtx(() => [
                _createTextVNode("专业查询")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(goMajorSearch)
            }, {
              default: _withCtx(() => [
                _createTextVNode("专业搜索")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_input, {
              "prefix-icon": _unref(Search),
              placeholder: "请输入院校名称",
              clearable: "",
              onClear: _unref(pageChange),
              modelValue: _unref(firstPageInfo).inputSearchCollegeName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(firstPageInfo).inputSearchCollegeName) = $event)),
              style: {"width":"180px"},
              onKeyup: _withKeys(_unref(pageChange), ["enter"])
            }, null, 8, ["prefix-icon", "onClear", "modelValue", "onKeyup"]),
            _createVNode(_component_el_button, {
              id: "inputSearchButton",
              onClick: _unref(pageChange)
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "deepBlueBtn",
              onClick: _unref(goProfessionSearch)
            }, {
              default: _withCtx(() => [
                _createTextVNode("职业查询")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _hoisted_8,
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_unref(ElScrollbar), {
        ref_key: "mainBodyScrollbar",
        ref: mainBodyScrollbar
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstPageInfo).collegeInfoArray, (item, i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_unref(goCollegeSituation)(i))
                  }, _toDisplayString(item.collegeName), 9, _hoisted_14)
                ]),
                _createElementVNode("div", _hoisted_15, " 内部编码：" + _toDisplayString(item.collegeCode), 1)
              ]))
            }), 256)),
            (_unref(firstPageInfo).collegeInfoArray.length == 0)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  style: {"margin-top":"100px"},
                  description: "暂无数据"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}
}

})